import statsStyle from "./stats.module.css";
import CountUp from 'react-countup';


const Card = ({counterOn,counterNumber,description}) => {    
    return (        
        <div className="col-12 col-md-6 col-xl-3 mt-4">
            <div className={statsStyle['stat-card']}>
                {counterOn &&
                    <CountUp 
                        start={0}
                        end={counterNumber}
                        duration={2}
                        delay={0}
                        onEnd={() => console.log('Ended!')}
                        onStart={() => console.log('Started!')}
                    />
                }
                <p>{description}</p>
            </div>
        </div>
    );
};

export default Card;